/* eslint-disable no-return-await */
import { useLocation } from 'react-router';
import { Navigate, Outlet } from 'react-router-dom';

import { getToken } from '../../helper/auth';
import { setAlertHrefReturn } from '../../hooks/actions';

const useAuth = () => getToken();

export const ProtectedRoutesAuth = () => {
  const location = useLocation();
  const isAuth = useAuth();
  if (!isAuth) {
    setAlertHrefReturn(location.pathname);
  } else {
    setAlertHrefReturn('/');
  }
  return isAuth ? (
    <Outlet />
  ) : (
    <Navigate to="/" replace state={{ from: location }} />
  );
};

export const ProtectedRoutesWithoutAuth = () => {
  const location = useLocation();
  const isAuth = useAuth();
  return !isAuth ? (
    <Outlet />
  ) : (
    <Navigate to="/" replace state={{ from: location }} />
  );
};
